import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia';

const pinia = createPinia();

// Add the Pinia store
Vue.use(PiniaVuePlugin);

export default pinia;
